import Link from "next/link"
import React from "react"
import ReactMarkdown from "react-markdown"
import rehypeRaw from "rehype-raw"

interface ProblemMarkdownProps {
    locale: string
    content: string
}
const ContentProblemMarkdown: React.FC<ProblemMarkdownProps> = ({ locale, content }) => {
    return (
        <ReactMarkdown
            components={{
                a: ({ href, children }: any) => {
                    const external = /http/.test(href)

                    return (
                        <Link
                            target={external ? '_blank' : '_self'}
                            href={external ? href : `/${locale}/${href.split(",").join("/")}/`} passHref>
                            {children}
                        </Link>
                    );
                },
            }}
            rehypePlugins={[rehypeRaw]}
        >
            {content}
        </ReactMarkdown>
    )
}

export default ContentProblemMarkdown

export const getImageUrl = (url: string) => {
    return encodeURI(url);
  };